/*
|-------------------------------------------------------------------------------
| 风控信息
|-------------------------------------------------------------------------------
*/
import { EXTERNAL_APPLY_CHANNEL } from '@/constants/common'
import { formatDefaultRcExt } from '@/utils/rcext'
import { defineStore } from '~/utils/store'
import type { IStoreState } from '~/utils/store'


// 参数参考: http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=564445510#id-%E5%A2%A8%E8%A5%BF%E5%93%A5%E4%BF%A1%E8%B4%B7-%E6%8E%88%E4%BF%A1-%E8%BF%94%E5%9B%9E%E5%8F%82%E6%95%B0%E7%BA%A6%E5%AE%9A

const rcextStore = defineStore({
  state: () => ({
    /** ===================手机信息================= */
    /**
     * 设备指纹
     */
    deviceId: '',

    /**
     * imei
     */
    imei: '',

    /**
     * 手机操作系统
     * 四个端的值都不一致，只能通过bridge获取，bridge是通过UA正则获取的，ios/android
     */
    os: '',

    /**
     * 手机品牌
     */
    model: '',

    /**
     * 客户端版本号
     */
    appversion: '',

    /**
     * 当前环境（司机端/乘客端)
     */
    applyChannel: EXTERNAL_APPLY_CHANNEL,

    /**
     * 安全部提供的唯一标识
     */
    // suuid: '',

    /** ===================风控参数================= */
    /**
     * omegaID
     */
    // omgId: '',
    /**
     * 设备指纹相关
     */
    sessionId: '',

    /** ===================区域信息================= */
    /**
     * gps经度
     */
    lng: '',

    /**
     * gps纬度
     */
    lat: '',

    /**
     *  区域
     */
    area: '',

    /**
     * 城市 id
     */
    city_id: '',
    // channel_id: null,
    /**
     * 手机服务
     */
    mobileService: '',
    /**
     * 下载商店
     */
    appStore: '',
    /**
     * 安装时间
     */
    appInstallTime: '',
  }),
  mutations: {
    update(state, data) {
      Object.assign(state, data)
    },
  },
  getters: {
    /**
     * 手机风控信息
     */
    deviceRcExt(state: any) {
      const rcExt = {
        deviceId: state.deviceId,
        imei: state.imei,
        os: state.os,
        model: state.model,
        appversion: state.appversion,
        applyChannel: state.applyChannel,
        mobileService: state.mobileService,
        appStore: state.appStore,
        appInstallTime: state.appInstallTime,
      }

      return formatDefaultRcExt(rcExt)
    },
    /**
     * 区域风控信息
     */
    areaRcExt(state: any) {
      const rcExt = {
        lng: state.lng,
        lat: state.lat,
        area: state.area,
        city_id: state.city_id,
      }

      return formatDefaultRcExt(rcExt)
    },
    /**
     * 常规风控信息
     */
    commonRcExt(state: any, getters: any) {
      const { deviceRcExt, areaRcExt } = getters
      const rcExt = {
        ...deviceRcExt,
        ...areaRcExt,
        lnSessionId: state.sessionId, // 设备指纹信息
        // omgId: state.omgId,
      }

      return formatDefaultRcExt(rcExt)
    },
  },
})

export default rcextStore
export type IRcextStoreState = IStoreState<
  typeof rcextStore.state
>
